// Portuguese translations
export const pt = {
  // Navigation
  'nav.overview': 'Visão geral',
  'nav.dashboard': 'Painel',
  'nav.analytics': 'Análises',
  'nav.reportingDashboard': 'Painel de relatórios',
  'nav.sales': 'Vendas',
  'nav.salesOrders': 'Pedidos de venda',
  'nav.purchase': 'Compras',
  'nav.purchaseOrders': 'Pedidos de compra',
  'nav.purchaseReview': 'Área de revisão',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Integração de fornecedores',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Criar sprint',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Planeamento semanal',
  'nav.scout.tagesplanung': 'Planeamento diário',
  'nav.scout.prequal': 'Chamadas PreQual',
  'nav.scout.missionen': 'Missões',
  'nav.scout.missionControl': 'Controlo de missões',
  'nav.scout.unternehmenssuche': 'Pesquisa de empresas',
  'nav.scout.preferences': 'Preferências',
  'nav.scout.hilfe': 'Ajuda',
  'nav.scout.scorecard': 'Painel de indicadores',
  'nav.poSprints': 'PO/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Visualização de suporte',
  'nav.navigationTiles': 'Blocos de navegação',
  'nav.styleGuide': 'Guia de estilo',
  'nav.inventory': 'Inventário',
  'nav.items': 'Artigos',
  'nav.warehouse': 'Armazém',
  'nav.picking': 'Separação',
  'nav.asn': 'ASN',
  'nav.returns': 'Devoluções',
  'nav.accounting': 'Contabilidade',
  'nav.accountsReceivable': 'Contas a receber',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Contactos',
  'nav.ai': 'IA',
  'nav.commandCenter': 'Centro de comando',
  'nav.workflows': 'Fluxos de trabalho',
  'nav.workflowManagement': 'Gestão de fluxos',
  'nav.projectManagement': 'Gestão de projetos',
  'nav.support': 'Suporte',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Tabela dinâmica',
  'nav.learning': 'Formação',
  'nav.curriculumPlanning': 'Planeamento curricular',
  'nav.learnerDashboard': 'Painel do formando',
  'nav.accessibleLearnerDashboard': 'Painel do formando acessível',
  'nav.settings': 'Definições',
  'nav.general': 'Geral',
  'nav.company': 'Empresa',
  'nav.addressManagement': 'Gestão de endereços',
  'nav.usersRoles': 'Utilizadores e funções',
  'nav.auditLog': 'Registo de auditoria',
  'nav.integrations': 'Integrações',
  'nav.appOverview': 'Visão geral das aplicações',
  'nav.appOverviewDescription': 'Clique numa aplicação para navegar ou arraste os blocos para reordenar',
  'header.help': 'Ajuda',
  'header.account': 'Conta',
  'header.portalName': 'Portal CLANDA',
  'header.preferences': 'Preferências',
  'header.language': 'Idioma',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': 'Eliminar',

  // Messages
  'message.success': 'Sucesso',
  'message.error': 'Erro',

  // Common
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.save': 'Guardar',
  'common.saveChanges': 'Guardar alterações',
  'common.close': 'Fechar',
  'common.reset': 'Repor',
  'common.back': 'Voltar',
  'common.loading': 'A carregar...',
  'common.search': 'Pesquisar',
  'common.search.placeholder': 'Pesquisar...',
  'common.filter': 'Filtrar',
  'common.sort': 'Ordenar',
  'common.add': 'Adicionar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.error': 'Erro',
  'common.remove': 'Remover',
  'common.minutesShort': '{{value}} min',
  'common.na': 'N/D',
  'common.days': 'dias',
  'common.status.active': 'ativo',
  'common.status.paused': 'pausado',
  'common.status.stopped': 'parado',
  'common.status.pending': 'pendente',
  'common.status.completed': 'concluído',
  'common.status.planned': 'Planeado',
  'common.status.inProgress': 'Em curso',
  'common.status.done': 'Concluído',
  'common.apply': 'Aplicar',
  'common.actions.filter': 'Filtrar',
  'common.actions.export': 'Exportar',
  'common.actions.search': 'Pesquisar',
  'common.dialog.defaultTitle': 'Diálogo',
  'common.all': 'Todos',
  'common.total': 'Total',
  'common.pending': 'Pendente',
  'common.assigned': 'Atribuído',
  'common.inProgress': 'Em curso',
  'common.completed': 'Concluído',
  'common.cancelled': 'Cancelado',
  'common.approved': 'Aprovado',
  'common.rejected': 'Rejeitado',
  'common.processing': 'A processar',
  'common.overdue': 'Em atraso',
  'common.partial': 'Parcial',
  'common.highPriority': 'Alta prioridade',
  'common.tableView': 'Vista em tabela',
  'common.cardView': 'Vista em cartões',
  'common.switchToTable': 'Mudar para vista em tabela',
  'common.switchToCard': 'Mudar para vista em cartões',
  'common.openMenu': 'Abrir menu',
  'common.details': 'Detalhes',
  'common.overview': 'Visão geral',
  'common.new': 'Novo',
  'common.draft': 'Rascunho',
  'common.shipped': 'Enviado',
  'common.delivered': 'Entregue',
  'common.received': 'Recebido',
  'common.inTransit': 'Em trânsito',
  'common.itemsPicked': 'Itens separados',
  'common.totalRefund': 'Reembolso total',
  'common.totalPrice': 'Preço total',
  'common.orderSummary': 'Resumo do pedido',
  'common.subtotal': 'Subtotal:',
  'common.tax': 'Imposto:',
  'common.discount': 'Desconto:',
  'common.totalColon': 'Total:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Hoje',
  'dateRange.yesterday': 'Ontem',
  'dateRange.last7Days': 'Últimos 7 dias',
  'dateRange.last14Days': 'Últimos 14 dias',
  'dateRange.last30Days': 'Últimos 30 dias',
  'dateRange.thisMonth': 'Este mês',
  'dateRange.custom': 'Personalizado',

  // Dashboard
  'widget.vsLastPeriod': 'vs período anterior',
  'table.showing': 'A mostrar',
  'table.of': 'de',
  'table.page': 'Página',
  'table.previous': 'Anterior',
  'table.next': 'Seguinte',
  'table.filterGroups': 'Grupos de filtros',
  'table.addFilterGroup': 'Adicionar grupo de filtros',
  'table.filterGroup': 'Grupo de filtros',
  'table.addCondition': 'Adicionar condição',
  'table.operator': 'Operador',
  'table.field': 'Campo',
  'table.noFilterGroups': 'Sem grupos de filtros.',
  'filter.operator.equals': 'é igual a',
  'filter.operator.not_equals': 'não é igual a',
  'filter.operator.contains': 'contém',
  'filter.operator.not_contains': 'não contém',
  'filter.operator.starts_with': 'começa com',
  'filter.operator.ends_with': 'termina com',
  'filter.operator.gt': 'maior que',
  'filter.operator.lt': 'menor que',
  'filter.operator.gte': 'pelo menos',
  'filter.operator.lte': 'no máximo',
  'filter.operator.between': 'entre',
  'filter.operator.in': 'é um de',
  'filter.operator.not_in': 'não é um de',
  'filter.operator.is_set': 'está definido',
  'filter.operator.is_not_set': 'não está definido',
  'filter.placeholder.value': 'Valor',
  'filter.placeholder.min': 'Mín',
  'filter.placeholder.max': 'Máx',
  'filter.placeholder.select': 'Selecionar…',
  'filter.placeholder.selectMultiple': 'Selecionar valores…',
  'filter.logic.and': 'E',
  'filter.logic.or': 'OU',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Definições da conta',

  // Consent
  'consent.title': 'Consentimento',
  'consent.label': 'Concordo com os termos e política de encomendas',
  'consent.description': 'Li e aceito os termos.',
  'consent.required': 'Por favor aceite os termos.',
  'consent.link.terms': 'Termos',

  // Contacts
  'contacts.title': 'Contactos',
  'contacts.role': 'Função',
  'contacts.role.admin': 'Admin',
  'contacts.role.billing': 'Faturação',
  'contacts.role.technical': 'Técnico',
  'contacts.role.other': 'Outro',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Autenticação',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'Olá {{name}}!',
  'learning.feed.levelInfo': 'Nível {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Offline',
  'learning.feed.streakLabel': 'Dias de sequência',
  'learning.feed.dailyGoal': 'Objetivo diário',
  'learning.feed.recommendedLessons': 'Lições recomendadas',
  'learning.feed.priority.high': 'Alto',
  'learning.feed.priority.medium': 'Médio',
  'learning.feed.priority.low': 'Baixo',
  'learning.feed.difficulty.easy': 'Fácil',
  'learning.feed.difficulty.medium': 'Médio',
  'learning.feed.difficulty.hard': 'Difícil',
  'learning.feed.aiRecommendation': 'Recomendação IA',
  'learning.feed.actions.start': 'Iniciar',
  'learning.feed.actions.skip': 'Saltar',
  'learning.feed.actions.reload': 'Recarregar',
  'learning.feed.empty.title': 'Todas as lições concluídas!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Concluiu todas as lições disponíveis hoje. Volte amanhã!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Pergunta {{current}} de {{total}}',
  'learning.quiz.options.true': 'Verdadeiro',
  'learning.quiz.options.false': 'Falso',
  'learning.quiz.actions.next': 'Seguinte',
  'learning.quiz.actions.finish': 'Terminar',
  'learning.quiz.actions.retry': 'Tentar novamente',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz passou!',
  'learning.quiz.result.failedTitle': 'Quiz não passou',
  'learning.quiz.result.scoreSummary': '{{correct}} de {{total}} corretas',
  'learning.quiz.result.xpEarned': '+{{xp}} XP obtidos',
  'learning.quiz.result.answersHeading': 'Respostas em detalhe',
  'learning.quiz.result.questionLabel': 'Pergunta {{index}}',
  'learning.quiz.result.yourAnswer': 'A sua resposta',
  'learning.quiz.result.correctAnswer': 'Resposta correta',
  'learning.lessonCard.difficulty.easy': 'Fácil',
  'learning.lessonCard.difficulty.medium': 'Médio',
  'learning.lessonCard.difficulty.hard': 'Difícil',
  'learning.lessonCard.status.completed': 'Concluído',
  'learning.lessonCard.reward': 'Recompensa',
  'learning.lessonCard.progress': 'Progresso',
  'learning.lessonCard.selectFormat': 'Escolher formato',
  'learning.lessonCard.prerequisites': 'Pré-requisitos',
  'learning.lessonCard.actions.start': 'Iniciar',
  'learning.lessonCard.actions.repeat': 'Repetir',
  'learning.lessonCard.actions.pause': 'Pausar',
  'learning.lessonCard.actions.complete': 'Concluir',
  'learning.lessonCard.actions.bookmark': 'Marcar',
  'learning.lessonCard.actions.unbookmark': 'Remover marcador',
  'learning.lessonCard.actions.collapse': 'Recolher',
  'learning.lessonCard.actions.expand': 'Expandir',
  'learning.lessonCard.goalLabel': 'Objetivo',
  'learning.lessonCard.formats.video': 'Ver vídeo',
  'learning.lessonCard.formats.text': 'Ler texto',
  'learning.lessonCard.formats.audio': 'Ouvir áudio',
  'learning.lessonCard.formats.cheatSheet': 'Resumo',
  'learning.lessonCard.formatUnknown': 'Desconhecido',
  'learning.accessible.title': 'Painel de formação',
  'learning.accessible.welcome': 'Bem-vindo de volta, {{name}}',
  'learning.accessible.voice.start': 'Voz',
  'learning.accessible.voice.stop': 'Parar de ouvir',
  'learning.accessible.voice.listening': 'A ouvir...',
  'learning.accessible.level': 'Nível',
  'learning.accessible.xpToNext': '{{value}} XP para o próximo nível',
  'learning.accessible.streak': 'Sequência',
  'learning.accessible.days': '{{value}} dias',
  'learning.accessible.keepItUp': 'Continue assim!',
  'learning.accessible.badges': 'Distintivos',
  'learning.accessible.achievementsEarned': 'Conquistas obtidas',
  'learning.accessible.tabs.overview': 'Visão geral',
  'learning.accessible.tabs.lessons': 'Lições',
  'learning.accessible.tabs.progress': 'Progresso',
  'learning.accessible.tabs.achievements': 'Conquistas',
  'learning.accessible.recentActivity': 'Atividade recente',
  'learning.accessible.noRecentActivity': 'Sem atividade recente',
  'learning.accessible.start': 'Iniciar',
  'learning.accessible.learningProgress': 'Progresso da formação',
  'learning.accessible.overallProgress': 'Progresso global',
  'learning.accessible.achievements': 'Conquistas',
  'learning.accessible.startingLesson': 'A iniciar lição {{id}}',
  'learning.accessible.difficulty.beginner': 'Iniciante',
  'learning.accessible.difficulty.intermediate': 'Intermédio',
  'learning.accessible.difficulty.advanced': 'Avançado',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Progresso da sequência',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Lição',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Sequência',
  'gamification.xpToast.source.badge': 'Distintivo',
  'gamification.xpToast.source.bonus': 'Bónus',
  'gamification.xpToast.levelUp.title': 'Subiu de nível!',
  'gamification.xpToast.levelUp.description': 'Alcançou o nível {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP obtidos',
  'gamification.xpToast.button.continue': 'Continuar',
  'gamification.xpToast.streakMilestone.title': 'Marco da sequência!',
  'gamification.xpToast.streakMilestone.description': 'Sequência de {{count}} dias alcançada!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP de bónus obtidos',
  'gamification.close': 'Fechar',

  // Wissensdatenbank
  'knowledgeBase.back': 'Voltar',
  'knowledgeBase.article.view': 'Ver',
  'knowledgeBase.article.views': '{{count}} visualizações',
  'knowledgeBase.article.helpful': '{{count}} úteis',
  'knowledgeBase.article.notHelpful': '{{count}} não úteis',
  'knowledgeBase.article.byAuthor': 'Por {{author}}',
  'knowledgeBase.header.title': 'Base de conhecimento',
  'knowledgeBase.header.subtitle': 'Encontre respostas às suas perguntas',
  'knowledgeBase.actions.filter': 'Filtrar',
  'knowledgeBase.actions.sort': 'Ordenar',
  'knowledgeBase.search.placeholder': 'Pesquisar na base de conhecimento...',
  'knowledgeBase.tabs.all': 'Todos',
  'knowledgeBase.stats.popular': 'Artigos mais populares',
  'knowledgeBase.stats.viewsCount': '{{count}} visualizações',
  'knowledgeBase.stats.helpful': 'Artigos mais úteis',
  'knowledgeBase.stats.ratingsCount': '{{count}} avaliações',
  'knowledgeBase.stats.total': 'Total de artigos',
  'knowledgeBase.stats.totalCount': '{{count}} artigos',
  'knowledgeBase.empty.title': 'Nenhum artigo encontrado',
  'knowledgeBase.empty.searching': 'Tente outros termos ou consulte as categorias.',
  'knowledgeBase.empty.default': 'Ainda não há artigos nesta categoria.',
  'knowledgeBase.difficulty.beginner': 'Iniciante',
  'knowledgeBase.difficulty.intermediate': 'Intermédio',
  'knowledgeBase.difficulty.advanced': 'Avançado',
  'knowledgeBase.categories.odoo-basics': 'Básicos Odoo',
  'knowledgeBase.categories.crm': 'CRM e vendas',
  'knowledgeBase.categories.inventory': 'Inventário e compras',
  'knowledgeBase.categories.accounting': 'Contabilidade',
  'knowledgeBase.categories.projects': 'Gestão de projetos',
  'knowledgeBase.categories.troubleshooting': 'Resolução de problemas',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Vídeo',
  'curriculum.videoDescription': 'Gravação de ecrã ou vídeo de prática',
  'curriculum.cheatSheet': 'Resumo',
  'curriculum.cheatSheetDescription': 'Para imprimir, códigos QR',
  'curriculum.test': 'Teste/Quiz',
  'curriculum.testDescription': 'Inquérito Odoo, 10 perguntas, 80%',
  'curriculum.checklist': 'Lista de verificação',
  'curriculum.checklistDescription': 'Tarefas Odoo, clicáveis',
  'curriculum.textLesson': 'Texto/Lição',
  'curriculum.textLessonDescription': 'Lição do curso Odoo',
  'curriculum.roleplay': 'Roleplay',
  'curriculum.roleplayDescription': 'Ao vivo com mentor/Benno',
  'curriculum.practice': 'Tarefa de prática',
  'curriculum.practiceDescription': 'Realizar com o cliente',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Visão semanal',
  'scout.wochenplanung.previousWeek': 'Semana anterior',
  'scout.wochenplanung.nextWeek': 'Próxima semana',
  'scout.wochenplanung.toast.appointmentAdded': 'Compromisso adicionado',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Compromisso atualizado',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Compromisso eliminado',
  'scout.wochenplanung.toast.slotUpdated': 'Slot atualizado',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Missão resolvida ou slot removido.',

  // Planning legend
  'scout.wochenplanung.legend.completed': 'concluído',
  'scout.wochenplanung.legend.planned': 'planeado',
  'scout.wochenplanung.legend.partial': 'parcialmente planeado',
  'scout.wochenplanung.legend.unplanned': 'por planejar',
  'scout.wochenplanung.legend.holiday': 'Feriado / Férias',

  // Missions section

  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Eliminar compromisso',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Tem a certeza que deseja eliminar este compromisso? Esta ação não pode ser desfeita.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Editar compromisso',
  'scout.wochenplanung.dialog.editAppointment.description': 'Deseja aplicar as alterações a este compromisso?',
  'scout.wochenplanung.employee': 'Colaborador',
  'scout.wochenplanung.selectEmployee': 'Selecionar colaborador',
  'scout.wochenplanung.allEmployees': 'Todos os colaboradores',
  'scout.wochenplanung.error.loading': 'Erro ao carregar o planeamento semanal',
  'scout.wochenplanung.error.retry': 'Tentar novamente',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': 'Visão da equipa',
  'scout.missionControl.teamMembers': 'Membros da equipa',
  'scout.missionControl.table.employee': 'Colaborador',
  'scout.missionControl.table.team': 'Equipa',
  'scout.missionControl.table.plzAreas': 'Áreas de código postal',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Erro ao carregar clientes existentes',
  'scout.missionen.bestandskunden.empty': 'Nenhum cliente existente encontrado',
  'scout.missionen.bestandskunden.search': 'Pesquisar clientes existentes...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} de {{total}} clientes existentes',
  'scout.missionen.wunschliste.industriesTitle': 'Indústrias preferidas',
  'scout.missionen.wunschliste.productsTitle': 'Produtos preferidos',
  'scout.missionen.wunschliste.plzTitle': 'Regiões de código postal preferidas',
  'scout.missionen.wunschliste.saveButton': 'Guardar',
  'scout.missionen.wunschliste.saved': 'Guardado',
  'scout.missionen.wunschliste.savedDesc': 'As suas preferências foram guardadas.',
  'scout.missionen.wunschliste.saveError': 'Erro',
  'scout.missionen.wunschliste.saveErrorDesc': 'Não foi possível guardar as preferências.',
  'scout.missionen.wunschliste.loadError': 'Erro ao carregar as preferências',
  'scout.tagesplanung.title': 'Planeamento diário',
  'scout.tagesplanung.addressUnknown': 'Morada desconhecida',
  'scout.tagesplanung.routeMapLabel': 'Mapa da rota',
  'scout.tagesplanung.routePlanning': 'Planeamento de rotas',
  'scout.tagesplanung.traffic': 'Trânsito',
  'scout.tagesplanung.deferNotPossible': 'Não é possível adiar',
  'scout.tagesplanung.deferMaxReached': 'Número máximo de adiamentos para hoje atingido (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Este lead já foi adiado hoje.',
  'scout.tagesplanung.dayCannotClose': 'Não é possível fechar o dia',
  'scout.tagesplanung.outstandingReports': 'Ainda existem {{count}} relatórios de visita em falta. Preencha todos antes de fechar o dia.',
  'scout.tagesplanung.andMore': '... e mais {{count}}',
  'scout.tagesplanung.tabs.planning': 'Plano do dia',
  'scout.tagesplanung.tasks.tabLabel': 'Tarefas',
  'scout.tagesplanung.tasks.empty': 'Sem tarefas',
  'scout.tagesplanung.tasks.loading': 'A carregar tarefas',
  'scout.tagesplanung.tasks.error': 'Não foi possível carregar as tarefas',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Estado',
  'scout.tagesplanung.tasks.filterStatusTodo': 'A fazer',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'Em curso',
  'scout.tagesplanung.tasks.filterStatusDone': 'Concluído',
  'scout.tagesplanung.tasks.priorityLabel': 'Prioridade',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Prazo',
  'scout.tagesplanung.tasks.dueNone': 'Sem prazo',
  'scout.lead.neukunde': 'Novo cliente — produto de nicho como porta de entrada',
  'scout.lead.bestandskunde': 'Cliente existente',
  'scout.metrics.besuche': 'Visitas',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Pedidos',
  'scout.metrics.umsatz': 'Receita',
  'scout.metrics.demoRate': 'Taxa de demos',
  'scout.composition.title': 'Composição da missão',
  'scout.composition.minBestandskunden': 'Mín. clientes existentes',
  'scout.composition.minQualifiziert': 'Mín. leads qualificados',
  'scout.composition.maxKaltbesuche': 'Máx. visitas a frio',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Adicionar compromisso',
  'scout.dailyPlanning.appointments': 'Compromissos',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Nenhum compromisso planeado para este dia',
  'scout.dailyPlanning.leadsByPriority': 'Leads (por prioridade)',
  'scout.dailyPlanning.noLeadsPlanned': 'Nenhum lead planeado para este dia',
  'scout.dailyPlanning.skipLead': 'Saltar lead',
  'scout.dailyPlanning.skipLeadConfirmation': 'Tem a certeza que deseja saltar este lead? Será adiado para o próximo dia.',
  'scout.dailyPlanning.skip': 'Saltar',
  'scout.dailyPlanning.removeLead': 'Remover lead',
  'scout.dailyPlanning.removeLeadConfirmation': 'Tem a certeza que deseja remover este lead? Será removido da rotação por completo.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Selecione uma missão para ver os leads',
  'scout.dailyPlanning.selectDate': 'Selecionar data',
  'scout.dailyPlanning.nextDay': 'Dia seguinte',
  'scout.dailyPlanning.closeDay': 'Fechar dia',
  'scout.dailyPlanning.reopenDay': 'Reabrir dia',
  'scout.dailyPlanning.noAcceptedLeads': 'Nenhum lead aceite para este dia.',
  'scout.dailyPlanning.statusSkipped': 'Saltado',
  'scout.dailyPlanning.selectAll': 'Selecionar tudo',
  'scout.dailyPlanning.selectAllLeads': 'Selecionar todos os leads',
  'scout.dailyPlanning.noSuggestions': 'Nenhuma sugestão.',
  'scout.dailyPlanning.previousDay': 'Dia anterior',
  'scout.dailyPlanning.calendarWeek': 'Semana {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visita',
  'scout.dailyPlanning.details': 'Detalhes',
  'scout.dailyPlanning.missionsLoading': 'A carregar missões…',
  'scout.dailyPlanning.leadsLoading': 'A carregar leads…',
  'scout.dailyPlanning.noLeadsFound': 'Nenhum lead encontrado',
  'scout.dailyPlanning.moreLeads': 'mais',
  'scout.dailyPlanning.dailyList': 'Lista do dia',
  'scout.dailyPlanning.unknown': 'Desconhecido',
  'scout.dailyPlanning.suggestedLeads': 'Leads sugeridos',
  'scout.dailyPlanning.error': 'Erro: {{error}}',
  'scout.dailyPlanning.help': 'Ajuda',
  'scout.dailyPlanning.bulkActions': 'Ações em massa',
  'scout.dailyPlanning.actionsCount': 'Ações ({{count}})',
  'scout.dailyPlanning.accept': 'Aceitar',
  'scout.dailyPlanning.reject': 'Rejeitar',
  'scout.dailyPlanning.selectLead': 'Selecionar lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Abrir detalhes de {{name}}',
  'scout.dailyPlanning.score': 'Pontuação: {{score}}',
  'scout.dailyPlanning.loading': 'A carregar planeamento diário',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Selecionar métrica para mapa de calor',
  'scout.scorecard.orders': 'Pedidos',
  'scout.scorecard.annualTargetOrders': 'Objetivo anual de pedidos',
  'scout.scorecard.comingSoon': 'Em breve',
  'scout.scorecard.kpiOverview': 'Visão geral de KPIs, atividades e principais setores',
  'scout.scorecard.activityByDay': 'Atividade por dia',
  'scout.scorecard.title': 'Painel de indicadores',
  'scout.scorecard.period.tag': 'Dia',
  'scout.scorecard.period.woche': 'Semana',
  'scout.scorecard.period.monat': 'Mês',
  'scout.scorecard.period.jahr': 'Ano',
  'scout.scorecard.kpiTilesHeading': 'Indicadores',
  'scout.scorecard.topBranchenProdukteHeading': 'Principais setores e produtos',
  'scout.scorecard.soll': 'Previsto',
  'scout.scorecard.forecast': 'Previsão',
  'scout.scorecard.gapToGo': 'Desvio a recuperar',
  'scout.scorecard.csvExport': 'Exportar CSV',
  'scout.scorecard.pdfExport': 'Exportar PDF',
  'scout.scorecard.table.date': 'Data',
  'scout.scorecard.table.visits': 'Visitas',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Pedidos',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Receita líquida',
  'scout.scorecard.table.total': 'Total',
  'scout.scorecard.topBranchen': 'Principais setores',
  'scout.scorecard.topProdukte': 'Principais produtos',
  'scout.scorecard.table.industry': 'Setor',
  'scout.scorecard.table.quantity': 'Quantidade (embalagens)',
  'scout.scorecard.table.revenue': 'Receita (€)',
  'scout.scorecard.table.product': 'Produto',
  'scout.scorecard.table.salesVolume': 'Volume de vendas',
  'scout.scorecard.table.customers': 'Clientes',
  'scout.scorecard.kpi.visits': 'Visitas',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Pedidos',
  'scout.scorecard.kpi.netRevenue': 'Receita líquida',
  'scout.scorecard.kpi.gebinde60l': 'Embalagem 60L',
  'scout.scorecard.kpi.gebinde25l': 'Embalagem 25L',
  'scout.scorecard.kpi.gebinde10l': 'Embalagem 10L',
  'scout.scorecard.emptyTitle': 'Sem dados',
  'scout.scorecard.emptyDescription': 'Sem dados de indicadores para o período selecionado.',
  'scout.scorecard.missionPerformanceTitle': 'Desempenho da missão',
  'scout.scorecard.missionMissionsCompleted': 'Missões concluídas',
  'scout.scorecard.missionConversionRate': 'Taxa de conversão',
  'scout.scorecard.missionTerritoryCoverage': 'Cobertura do território',
  'scout.scorecard.viewMissionDetails': 'Ver detalhes',
  'scout.scorecard.adjustTargets': 'Ajustar objetivos',
  'scout.scorecard.annualTarget': 'Objetivo anual',
  'scout.scorecard.annualTargetVisits': 'Objetivo anual de visitas',
  'scout.scorecard.annualTargetDemos': 'Objetivo anual de demos',
  'scout.scorecard.annualTargetNetRevenue': 'Receita líquida (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Objetivo anual de receita líquida em euros',
  'scout.scorecard.monthlyOverrides': 'Variações mensais',
  'scout.scorecard.table.month': 'Mês',
  'scout.scorecard.table.reason': 'Motivo',
  'scout.scorecard.derivedTargets': 'Objetivos derivados',
  'scout.scorecard.dailyTargetLabel': 'Objetivo diário: {{count}} visitas',
  'scout.scorecard.weeklyTargetLabel': 'Objetivo semanal: {{count}} visitas',
  'scout.scorecard.save': 'Guardar',
  'scout.scorecard.heatmap.visits': 'Visitas',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Receita',
  'scout.scorecard.heatmap.low': 'Baixo',
  'scout.scorecard.heatmap.high': 'Alto',
  'scout.scorecard.heatmap.scaleA11y': 'Escala de cor de baixo a alto',
  'scout.scorecard.heatmap.loading': 'A carregar mapa…',

  // Scout mission control
  'scout.missionControl.teamOverview': 'A sua equipa e respetivas áreas de código postal',
  'scout.missionControl.jokerLimitPerDay': 'Limite de joker / dia',
  'scout.missionControl.jokerLimitUpdated': 'Limite de joker atualizado.',
  'scout.missionControl.jokerLimitSaveFailed': 'Não foi possível guardar o limite de joker.',
  'scout.missionControl.selectTeam': 'Selecionar equipa',
  'scout.missionControl.none': 'Nenhum',
  'scout.missionControl.addPlzAreaFor': 'Adicionar área de CP para',
  'scout.missionControl.addPlzArea': 'Adicionar área de CP',
  'scout.missionControl.noTeamMembersFound': 'Nenhum membro da equipa encontrado.',
  'scout.missionControl.orders': 'Pedidos',
  'scout.missionControl.resetSettings': 'Repor definições',
  'scout.missionControl.saveSettings': 'Guardar definições',
  'scout.missionControl.territorySaturation': 'Saturação do território (CP)',
  'scout.missionControl.day': 'Dia',
  'scout.missionControl.selectDay': 'Selecionar dia',
  'scout.missionControl.week': 'Semana',
  'scout.missionControl.selectWeek': 'Selecionar semana',
  'scout.missionControl.month': 'Mês',
  'scout.missionControl.selectMonth': 'Selecionar mês',
  'scout.missionControl.planFulfillment': 'Cumprimento do plano',
  'scout.missionControl.plzPrefixPlaceholder': 'Prefixo de CP (ex.: 70)',
  'scout.missionControl.plzPrefix': 'Prefixo de CP',
  'scout.missionControl.addPlzToWhitelist': 'Adicionar prefixo de CP à lista branca',
  'scout.missionControl.addPlzToGreylist': 'Adicionar prefixo de CP à lista cinzenta',
  'scout.missionControl.addPlzToYellowlist': 'Adicionar prefixo de CP à lista amarela',
  'scout.missionControl.addNewTeamMember': 'Adicionar novo membro da equipa',
  'scout.missionControl.lastModified': 'Última alteração',
  'scout.missionControl.outsideAreaRules': 'Regras fora da área',
  'scout.missionControl.outsidePlzPolicy': 'Política para CP fora das listas',
  'scout.missionControl.enableOutsideWarning': 'Ativar aviso para CP fora da área',
  'scout.missionControl.requireOutsideApproval': 'Aprovação obrigatória para CP fora da área',
  'scout.missionControl.rejectOutsidePlz': 'Rejeitar CP fora da área',
  'scout.missionControl.checkPlz': 'Verificar CP ou prefixo de CP',
  'scout.missionControl.check': 'Verificar',
  'scout.missionControl.error': 'Erro',
  'scout.missionControl.success': 'Sucesso',
  'scout.missionControl.userProfileNotFound': 'Perfil de utilizador não encontrado',
  'scout.missionControl.plzAreasUpdated': 'Áreas de CP atualizadas',
  'scout.missionControl.plzAreasSaveFailed': 'Não foi possível guardar as áreas de CP',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Configuração de representante',
  'scout.missionControl.repConfig.repName': 'Nome / E-mail',
  'scout.missionControl.repConfig.industries': 'Setores',
  'scout.missionControl.repConfig.products': 'Produtos',
  'scout.missionControl.repConfig.plz': 'CP',
  'scout.missionControl.repConfig.loadError': 'Não foi possível carregar a configuração de representantes',
  'scout.missionControl.repConfig.saveError': 'Falha ao guardar',
  'scout.missionControl.repConfig.savedTitle': 'Guardado',
  'scout.missionControl.repConfig.savedDesc': 'Configuração de representante atualizada',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Limite de joker por dia',
  'scout.missionControl.jokerConfig.description': 'Número máximo de utilizações de joker por representante e por dia.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Máx. por dia',
  'scout.missionControl.jokerConfig.loadError': 'Não foi possível carregar a configuração de joker',
  'scout.missionControl.jokerConfig.saveError': 'Falha ao guardar',
  'scout.missionControl.jokerConfig.savedTitle': 'Guardado',
  'scout.missionControl.jokerConfig.savedDesc': 'Limite de joker atualizado',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Taxa de demos',
  'scout.missionControl.diagnostics.visitDepth': 'Profundidade da visita',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Selecionar todos os resultados',
  'scout.unternehmenssuche.openingHours': 'HORÁRIO',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporariamente encerrado',
  'scout.unternehmenssuche.startSearch': 'Iniciar pesquisa',
  'scout.unternehmenssuche.searchRunning': 'A pesquisar...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Altere os critérios de pesquisa ou tente novamente.',
  'scout.unternehmenssuche.selectCompanyType': 'Selecionar tipo de empresa',
  'scout.unternehmenssuche.openingHoursTime': 'Horário',
  'scout.unternehmenssuche.noTimeNeeded': 'Sem indicação de hora',
  'scout.unternehmenssuche.addConditions': 'Adicione condições para refinar a pesquisa',
  'scout.unternehmenssuche.addCondition': 'Adicionar condição',
  'scout.unternehmenssuche.addGroup': 'Adicionar grupo',
  'scout.unternehmenssuche.savedSearchName': 'Nome da pesquisa guardada',
  'scout.unternehmenssuche.saveCurrentSearch': 'Guardar pesquisa atual',
  'scout.unternehmenssuche.savedSearches': 'Pesquisas guardadas',
  'scout.unternehmenssuche.noSavedSearches': 'Nenhuma pesquisa guardada.',
  'scout.unternehmenssuche.keywordPlaceholder': 'ex.: Restaurante, Bar, Padaria',
  'scout.unternehmenssuche.addWaypoint': 'Adicionar paragem',
  'scout.unternehmenssuche.locationPlaceholder': 'ex.: Lisboa Rossio',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Mostrar ou ocultar filtros adicionais',
  'scout.unternehmenssuche.additionalFilters': 'Filtros adicionais',
  'scout.unternehmenssuche.saveSearchAsFile': 'Guardar pesquisa como ficheiro',
  'scout.unternehmenssuche.loadSearchFromFile': 'Carregar pesquisa de ficheiro',
  'scout.unternehmenssuche.checkSearchTerms': 'Verifique os termos de pesquisa ou tente novamente.',

  // Search overlay
  'search.overlay.hint': 'Escreva e prima Enter ou clique em Pesquisar.',
  'search.overlay.placeholder': 'Pesquisar (/) recursos, documentação e mais',
  'search.overlay.searchLabel': 'Pesquisar',
  'search.overlay.noResults': 'Nenhum resultado para "{{query}}"',
  'search.overlay.tryDifferent': 'Use outros termos ou verifique a ortografia.',
  'search.overlay.topResults': 'Principais resultados',
  'search.overlay.documentation': 'Documentação · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Local + raio',
  'scout.unternehmenssuche.routeCorridor': 'Rota + corredor',
  'scout.unternehmenssuche.withoutLocation': 'Sem localização',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Mapa de calor de atividade (CP-2)',
  'scout.preferences.defaultRegionLabel': 'Região padrão',
  'scout.preferences.selectRegionPlaceholder': 'Selecionar região',
  'scout.preferences.defaultStatusLabel': 'Estado padrão',
  'scout.preferences.selectDefaultStatus': 'Selecionar estado padrão',
  'scout.preferences.statusDraft': 'Rascunho',
  'scout.preferences.statusActive': 'Ativo',
  'scout.preferences.statusCompleted': 'Concluído',
  'scout.preferences.statusArchived': 'Arquivado',
  'scout.preferences.saving': 'A guardar...',
  'scout.preferences.plzPrefixes': 'Prefixos de CP para missões',
  'scout.preferences.plzPrefixesPlaceholder': 'Introduza prefixos de CP separados por vírgula (ex.: 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Comprimento máx. da rota (km)',
  'scout.preferences.maxRouteLengthDescription': 'Comprimento máximo da rota em quilómetros',
  'scout.preferences.autoGenerateMissions': 'Gerar missões automaticamente (automação noturna)',
  'scout.preferences.autoGenerateDescription': 'Quando ativo, as missões são geradas automaticamente com base nas suas definições.',
  'scout.preferences.defaultAssigneeLabel': 'Responsável padrão',
  'scout.preferences.defaultAssigneePlaceholder': 'Introduza o responsável padrão',
  'scout.preferences.defaultAssigneeAria': 'Responsável padrão',
  'scout.preferences.defaultLeadCountLabel': 'Número padrão de leads',
  'scout.preferences.defaultLeadCountAria': 'Número padrão de leads',
  'scout.preferences.defaultDurationLabel': 'Duração padrão (dias)',
  'scout.preferences.defaultDurationAria': 'Duração padrão em dias',
  'scout.preferences.autoAssignLabel': 'Atribuir missões automaticamente ao responsável padrão',
  'scout.preferences.productFamiliesLabel': 'Famílias de produtos',
  'scout.preferences.industryCodesLabel': 'Setores',
  'scout.preferences.keywordsLabel': 'Palavras-chave',
  'scout.preferences.keywordsPlaceholder': 'ex.: betão, pavimento',
  'scout.preferences.minLeadsLabel': 'Mín. leads por missão',
  'scout.preferences.minLeadsAria': 'Mínimo de leads por missão',
  'scout.preferences.maxLeadsLabel': 'Máx. leads por missão',
  'scout.preferences.maxLeadsAria': 'Máximo de leads por missão',
  'scout.preferences.dailyQuotaLabel': 'Número de missões por dia',
  'scout.preferences.dailyQuotaAria': 'Máximo de missões por dia',
  'scout.preferences.dailyQuotaHelper': 'Número máximo de missões geradas automaticamente por dia (1-3)',
  'scout.dailyPlanning.inField': 'Em deslocações',
  'scout.dailyPlanning.completed': 'Concluído',
  'scout.dailyPlanning.openDay': 'Abrir dia',
  'scout.dailyPlanning.dayMarkedCompleted': 'Este dia está marcado como concluído.',
  'scout.dailyPlanning.statusVisited': 'Visitado',
  'scout.dailyPlanning.statusPlanned': 'Planeado',
  'scout.dailyPlanning.statusCompleted': 'Concluído',
  'scout.createMission.title': 'Criar nova missão',
  'scout.createMission.description': 'Escolher nome, filtros e atribuições',
  'scout.createMission.nameLabel': 'Nome',
  'scout.createMission.nameRequired': 'O nome é obrigatório',
  'scout.createMission.namePlaceholder': 'ex. Lisboa Norte — Refrigeração',
  'scout.createMission.nameAria': 'Nome da missão',
  'scout.createMission.regionLabel': 'Região (opcional)',
  'scout.createMission.regionPlaceholder': 'ex. CP 10xxx',
  'scout.createMission.regionAria': 'Região ou CP',
  'scout.createMission.ownerLabel': 'Responsável',
  'scout.createMission.ownerPlaceholder': 'Endereço de e-mail',
  'scout.createMission.ownerAria': 'E-mail do responsável',
  'scout.createMission.themeLabel': 'Tema (opcional)',
  'scout.createMission.themePlaceholder': 'ex. Refrigeração',
  'scout.createMission.themeAria': 'Tema da missão',
  'scout.createMission.productLabel': 'Produto (opcional)',
  'scout.createMission.productPlaceholder': 'ex. K-2000',
  'scout.createMission.productAria': 'Produto',
  'scout.createMission.cancel': 'Cancelar',
  'scout.createMission.save': 'Guardar',
  'scout.createMission.saveBusy': 'A guardar…',
  'scout.createMission.cancelAria': 'Cancelar criação da missão',
  'scout.createMission.saveAria': 'Guardar missão',
  'scout.createMission.saveBusyAria': 'A guardar missão',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'Gerir definições da aplicação e opções de personalização',
  'settings.typography.title': 'Tipografia',
  'settings.typography.description': 'Ajustar tamanho e densidade do texto para melhor legibilidade ou mais informação',
  'settings.typography.scale.title': 'Tamanho do texto',
  'settings.typography.scale.description': 'Padrão corresponde à base; Conforto aumenta o texto para sessões longas',
  'settings.typography.scale.ariaLabel': 'Predefinição de tamanho de texto',
  'settings.typography.scale.compact': 'Compacto',
  'settings.typography.scale.standard': 'Padrão',
  'settings.typography.scale.comfort': 'Conforto',
  'settings.tabs.appearance': 'Aparência',
  'settings.tabs.account': 'Conta',
  'settings.tabs.notifications': 'Notificações',
  'settings.tabs.security': 'Segurança',
  'settings.language.title': 'Definições de idioma',
  'settings.language.description': 'Selecione o idioma preferido para a interface',
  'settings.language.interfaceLanguage': 'Idioma da interface',
  'settings.language.interfaceLanguageDesc': 'Selecione o idioma para menus, botões e elementos da interface',
  'settings.theme.title': 'Esquema de cores',
  'settings.theme.description': 'Personalize a aparência e cores da sua interface',
  'settings.theme.predefinedThemes': 'Quer escolher entre 10 temas predefinidos?',
  'settings.theme.goToThemeSettings': 'Ir para definições de tema',
  'settings.themeSettings.title': 'Definições de tema',
  'settings.themeSettings.description': 'Personalize a aparência da aplicação com temas predefinidos',
  'settings.themeSettings.themeDetails': 'Detalhes do tema',
  'settings.themeSettings.themeId': 'ID do tema:',
  'settings.themeSettings.colorScheme': 'Esquema de cores:',
  'settings.account.profile.title': 'Informação do perfil',
  'settings.account.profile.description': 'Atualizar dados pessoais e da conta',
  'settings.account.profile.name': 'Nome',
  'settings.account.profile.email': 'E-mail',
  'settings.account.profile.role': 'Função',
  'settings.account.profile.department': 'Departamento',
  'settings.account.profile.editProfile': 'Editar perfil',
  'settings.account.data.title': 'Gestão de dados',
  'settings.account.data.description': 'Gerir sincronização e cópias de segurança',
  'settings.account.data.cloudSync': 'Sincronização na cloud',
  'settings.account.data.cloudSyncEnabled': 'As suas definições são sincronizadas na cloud',
  'settings.account.data.cloudSyncDisabled': 'Sincronização na cloud desativada (flag de funcionalidade)',
  'settings.account.data.syncNow': 'Sincronizar agora',
  'settings.notifications.title': 'Definições de notificações',
  'settings.notifications.description': 'Configurar como recebe notificações',
  'settings.notifications.email.title': 'Notificações por e-mail',
  'settings.notifications.email.description': 'Receber notificações por e-mail',
  'settings.notifications.push.title': 'Notificações push',
  'settings.notifications.push.description': 'Receber notificações push no browser',
  'settings.notifications.system.title': 'Alertas do sistema',
  'settings.notifications.system.description': 'Notificações importantes do sistema',
  'settings.notifications.configure': 'Configurar',
  'settings.security.title': 'Definições de segurança',
  'settings.security.description': 'Gerir segurança da conta e privacidade',
  'settings.security.password.title': 'Palavra-passe',
  'settings.security.password.lastChanged': 'Alterada há 30 dias',
  'settings.security.password.change': 'Alterar',
  'settings.security.twoFactor.title': 'Autenticação de dois fatores',
  'settings.security.twoFactor.description': 'Adicionar uma camada extra de segurança',
  'settings.security.twoFactor.enable': 'Ativar',
  'settings.security.sessions.title': 'Gestão de sessões',
  'settings.security.sessions.description': 'Gerir sessões ativas',
  'settings.security.sessions.view': 'Ver sessões',
  'settings.company.title': 'Definições da empresa',
  'settings.company.description': 'Gerir informação e definições da empresa',
  'settings.company.edit': 'Editar empresa',
  'settings.company.saveChanges': 'Guardar alterações',
  'settings.company.cancel': 'Cancelar',
  'settings.company.tabs.general': 'Geral',
  'settings.company.tabs.contact': 'Contacto',
  'settings.company.tabs.billing': 'Faturação',
  'settings.company.tabs.branding': 'Identidade visual',
  'settings.company.general.companyInfo': 'Informação da empresa',
  'settings.company.general.companyName': 'Nome da empresa',
  'settings.company.general.legalName': 'Nome legal',
  'settings.company.general.taxId': 'NIF',
  'settings.company.general.registrationNumber': 'Número de registo',
  'settings.company.general.industry': 'Setor',
  'settings.company.general.foundedYear': 'Ano de fundação',
  'settings.company.general.employees': 'Número de colaboradores',
  'settings.company.general.industry.technology': 'Tecnologia',
  'settings.company.general.industry.manufacturing': 'Indústria',
  'settings.company.general.industry.retail': 'Retalho',
  'settings.company.general.industry.healthcare': 'Saúde',
  'settings.company.general.industry.finance': 'Finanças',
  'settings.company.general.industry.other': 'Outro',
  'settings.company.address.title': 'Informação de morada',
  'settings.company.address.street': 'Morada',
  'settings.company.address.city': 'Cidade',
  'settings.company.address.state': 'Estado/Região',
  'settings.company.address.zipCode': 'Código postal',
  'settings.company.address.country': 'País',
  'settings.company.address.country.us': 'Estados Unidos',
  'settings.company.address.country.ca': 'Canadá',
  'settings.company.address.country.uk': 'Reino Unido',
  'settings.company.address.country.de': 'Alemanha',
  'settings.company.address.country.fr': 'França',
  'settings.company.address.country.other': 'Outro',
  'settings.company.contact.title': 'Informação de contacto',
  'settings.company.contact.phone': 'Telefone',
  'settings.company.contact.email': 'E-mail',
  'settings.company.contact.website': 'Site',
  'settings.company.contact.supportEmail': 'E-mail de suporte',
  'settings.company.billing.title': 'Definições de faturação',
  'settings.company.billing.currency': 'Moeda',
  'settings.company.billing.taxRate': 'Taxa de imposto (%)',
  'settings.company.billing.paymentTerms': 'Condições de pagamento',
  'settings.company.billing.billingCycle': 'Ciclo de faturação',
  'settings.company.billing.paymentTerms.net15': 'Líquido 15',
  'settings.company.billing.paymentTerms.net30': 'Líquido 30',
  'settings.company.billing.paymentTerms.net45': 'Líquido 45',
  'settings.company.billing.paymentTerms.net60': 'Líquido 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Vencimento à receção',
  'settings.company.billing.cycle.monthly': 'Mensal',
  'settings.company.billing.cycle.quarterly': 'Trimestral',
  'settings.company.billing.cycle.annually': 'Anual',
  'settings.company.billing.cycle.custom': 'Personalizado',
  'settings.company.billing.summary.title': 'Resumo de faturação',
  'settings.company.billing.summary.currentPlan': 'Plano atual',
  'settings.company.billing.summary.monthlyCost': 'Custo mensal',
  'settings.company.billing.summary.nextBillingDate': 'Próxima data de faturação',
  'settings.company.billing.summary.paymentMethod': 'Método de pagamento',
  'settings.company.billing.summary.status': 'Estado',
  'settings.company.billing.summary.active': 'Ativo',
  'settings.company.branding.title': 'Identidade visual e aparência',
  'settings.company.branding.logo': 'Logótipo da empresa',
  'settings.company.branding.uploadLogo': 'Carregar logótipo',
  'settings.company.branding.logoHint': 'PNG, JPG até 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Carregar favicon',
  'settings.company.branding.faviconHint': 'ICO, PNG até 1MB',
  'settings.company.branding.primaryColor': 'Cor primária',
  'settings.company.branding.secondaryColor': 'Cor secundária',
  'settings.usersRoles.stats.totalUsers': 'Total de utilizadores',
  'settings.usersRoles.stats.activeUsers': 'utilizadores ativos',
  'settings.usersRoles.stats.totalRoles': 'Total de funções',
  'settings.usersRoles.stats.roleConfigurations': 'Configurações de funções',
  'settings.userManagement.title': 'Gestão de utilizadores',
  'settings.userManagement.description': 'Gerir utilizadores, funções e definições do sistema',
  'settings.userManagement.addUser': 'Adicionar utilizador',
  'settings.userManagement.editUser': 'Editar utilizador',
  'settings.userManagement.createNewUser': 'Criar novo utilizador',
  'settings.userManagement.updateUserInfo': 'Atualizar informação do utilizador',
  'settings.userManagement.addNewUser': 'Adicionar novo utilizador ao sistema',
  'settings.userManagement.tabs.users': 'Utilizadores',
  'settings.userManagement.tabs.appAccess': 'Acesso à aplicação',
  'settings.userManagement.tabs.roles': 'Funções',
  'settings.userManagement.toast.userCreated': 'Utilizador criado com sucesso',
  'settings.userManagement.toast.userUpdated': 'Utilizador atualizado com sucesso',
  'settings.userManagement.toast.userDeleted': 'Utilizador eliminado com sucesso',
  'settings.userManagement.toast.roleCreated': 'Função criada com sucesso',
  'settings.userManagement.toast.roleUpdated': 'Função atualizada com sucesso',
  'settings.userManagement.toast.roleDeleted': 'Função eliminada com sucesso',
  'settings.userManagement.toast.error': 'Não foi possível criar o utilizador',
  'settings.userManagement.toast.errorUpdate': 'Não foi possível atualizar o utilizador',
  'settings.userManagement.toast.errorDelete': 'Não foi possível eliminar o utilizador',
  'settings.userManagement.toast.errorRoleCreate': 'Não foi possível criar a função',
  'settings.userManagement.toast.errorRoleUpdate': 'Não foi possível atualizar a função',
  'settings.userManagement.toast.errorRoleDelete': 'Não foi possível eliminar a função',
  'settings.integrations.settings.security.enabled': 'Ativado',
  'settings.integrations.settings.security.disabled': 'Desativado',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'Contactos CRM',
  'crm.contacts.description': 'Gerir contactos de clientes e fornecedores com informação de morada',
  'crm.contacts.add': 'Adicionar contacto',
  'crm.contacts.edit': 'Editar contacto',
  'crm.contacts.delete': 'Eliminar contacto',
  'crm.contacts.view360': 'Vista 360°',
  'crm.contacts.unassigned': 'Não atribuído',
  'crm.contacts.type.customer': 'Cliente',
  'crm.contacts.type.supplier': 'Fornecedor',
  'crm.contacts.type.partner': 'Parceiro',
  'crm.contacts.type.prospect': 'Prospeto',
  'crm.contacts.status.active': 'Ativo',
  'crm.contacts.status.inactive': 'Inativo',
  'crm.contacts.status.suspended': 'Suspenso',
  'crm.contacts.validation.companyRequired': 'Nome da empresa é obrigatório',
  'crm.contacts.validation.streetRequired': 'Morada é obrigatória',
  'crm.contacts.validation.postalRequired': 'Código postal é obrigatório',
  'crm.contacts.validation.cityRequired': 'Cidade é obrigatória',
  'crm.contacts.validation.countryRequired': 'País é obrigatório',
  'crm.contacts.validation.nameRequired': 'Nome do contacto é obrigatório',
  'crm.contacts.validation.emailInvalid': 'Endereço de e-mail inválido',
  'crm.contacts.validation.phoneRequired': 'Telefone é obrigatório',
  'crm.contacts.validation.salesPersonRequired': 'Comercial é obrigatório',
  'crm.contacts.validation.ordererNameRequired': 'Nome do encomendador é obrigatório',
  'crm.contacts.validation.roleRequired': 'Função é obrigatória',
  'crm.contacts.validation.hoursRequired': 'Horas são obrigatórias',
  'crm.openMenu': 'Abrir menu',

  // CRM - Leads
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Gerir leads de vendas e acompanhar conversão',
  'crm.leads.add': 'Adicionar lead',
  'crm.leads.edit': 'Editar lead',
  'crm.leads.delete': 'Eliminar lead',
  'crm.leads.status.new': 'Novo',
  'crm.leads.status.contacted': 'Contactado',
  'crm.leads.status.qualified': 'Qualificado',
  'crm.leads.status.proposal': 'Proposta',
  'crm.leads.status.negotiation': 'Negociação',
  'crm.leads.status.closedWon': 'Ganho',
  'crm.leads.status.closedLost': 'Perdido',
  'crm.leads.source.website': 'Site',
  'crm.leads.source.referral': 'Recomendação',
  'crm.leads.source.email': 'E-mail',
  'crm.leads.source.phone': 'Telefone',
  'crm.leads.source.social': 'Redes sociais',
  'crm.leads.source.other': 'Outro',
  'crm.leads.value': 'Valor',
  'crm.leads.lastContact': 'Último contacto',
  'crm.leads.notes': 'Notas',
  'crm.leads.search': 'Pesquisar leads...',
  'crm.leads.filterByStatus': 'Filtrar por estado',
  'crm.leads.filterBySource': 'Filtrar por origem',
  'crm.leads.totalLeads': 'Total de leads',
  'crm.leads.pipelineValue': 'Valor do pipeline',
  'crm.leads.qualifiedLeads': 'Leads qualificados',

  // Visit Report
  'visitReport.title': 'Relatório de visita',
  'visitReport.createTitle': 'Criar relatório de visita',
  'visitReport.titleFor': 'Relatório de visita para {{name}}',
  'visitReport.visitType': 'Tipo de visita',
  'visitReport.coldVisit': 'Visita a frio',
  'visitReport.appointment': 'Compromisso',
  'visitReport.salesOutcome': 'Resultado da venda',
  'visitReport.noContact': 'Sem contacto',
  'visitReport.conversation': 'Conversa',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Pedido',
  'visitReport.orderValue': 'Valor do pedido (EUR)',
  'visitReport.nextStep': 'Próximo passo',
  'visitReport.callback': 'Recontactar',
  'visitReport.sendOffer': 'Enviar proposta',
  'visitReport.revisit': 'Nova visita',
  'visitReport.completed': 'Concluído',
  'visitReport.appointmentWindow': 'Janela de compromisso (opcional)',
  'visitReport.from': 'De',
  'visitReport.to': 'Até',
  'visitReport.contactName': 'Nome do interlocutor',
  'visitReport.enterName': 'Introduzir nome',
  'visitReport.roleFunction': 'Função / papel',
  'visitReport.enterRole': 'Introduzir função',
  'visitReport.isDecisionMaker': 'É decisor?',
  'visitReport.decisionMakerName': 'Nome do decisor',
  'visitReport.decisionMakerRole': 'Função do decisor',
  'visitReport.email': 'E-mail (opcional)',
  'visitReport.phone': 'Telefone (opcional)',
  'visitReport.notes': 'Notas (opcional)',
  'visitReport.additionalInfo': 'Informação adicional...',
  'visitReport.productsDiscussed': 'Produtos discutidos?',
  'visitReport.annualDemand': 'Procura anual',
  'visitReport.select': 'Selecionar',
  'visitReport.interest': 'Interesse',
  'visitReport.interestHigh': 'alto',
  'visitReport.interestMedium': 'médio',
  'visitReport.interestLow': 'baixo',
  'visitReport.modelFeedback': 'A recomendação do sistema foi adequada?',
  'visitReport.feedbackYes': 'Sim',
  'visitReport.feedbackPartially': 'Parcialmente',
  'visitReport.feedbackNo': 'Não',
  'visitReport.feedbackNotSeen': 'Não visto',
  'visitReport.branchCorrect': 'Setor correto? (opcional)',
  'visitReport.selectBranch': 'Selecionar setor',
  'visitReport.branchConstruction': 'Construção',
  'visitReport.branchIndustry': 'Indústria',
  'visitReport.branchTrade': 'Comércio',
  'visitReport.branchService': 'Serviços',
  'visitReport.noInterestReason': 'Motivo de falta de interesse',
  'visitReport.wrongProduct': 'Produto errado',
  'visitReport.wrongTiming': 'Momento inadequado',
  'visitReport.existingSupplier': 'Fornecedor atual',
  'visitReport.noBudget': 'Sem orçamento',
  'visitReport.noNeed': 'Sem necessidade',
  'visitReport.decisionMakerNotReached': 'Decisor não contactado',
  'visitReport.additionalRemarks': 'Outras observações (opcional)',
  'visitReport.error': 'Erro',
  'visitReport.validationError': 'Selecione tipo de visita e resultado da venda.',
  'visitReport.deferralNotPossible': 'Não é possível adiar',
  'visitReport.maxDeferralReached': 'Já adiou o último relatório. Preencha-o, por favor.',
  'visitReport.reportDeferred': 'Relatório adiado',
  'visitReport.deferralMessage': 'Pode preencher o relatório mais tarde.',
  'visitReport.reportCreated': 'Relatório de visita criado',
  'visitReport.reportSaved': 'Relatório de visita guardado.',
  'visitReport.reportSavedFor': 'Relatório de visita para {{name}} guardado.',
  'visitReport.reportError': 'Não foi possível criar o relatório de visita.',
  'visitReport.stepOf': 'Passo {{current}} de {{total}}',
  'visitReport.back': 'Voltar',
  'visitReport.cancel': 'Cancelar',
  'visitReport.inAHurry': 'Tenho pressa',
  'visitReport.next': 'Seguinte',
  'visitReport.saving': 'A guardar...',
  'visitReport.finishVisit': 'Concluir visita',
  'visitReport.contactNotes': 'Informação adicional sobre o interlocutor...',
  'visitReport.callingQueue.prompt': 'Preparar chamada de agendamento por IA para este lead?',
  'visitReport.callingQueue.yes': 'Sim, adicionar à fila',
  'visitReport.callingQueue.no': 'Não',
  'visitReport.callingQueue.toast': 'Lead adicionado à fila de chamadas.',

  // --- SS-145: admin ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': 'Fechar',
  'modals.assignMissionModal.searchPlaceholder': 'Pesquisar (título/setor)',
  'modals.assignMissionModal.searchAriaLabel': 'Pesquisar',
  'modals.missionQuickViewModal.description': 'Visão rápida da missão. Abra a página da missão para detalhes.',
  'modals.missionQuickViewModal.close': 'Fechar',
  'modals.missionQuickViewModal.openDetails': 'Abrir detalhes',
  'modals.missionQuickViewModal.openDetailsAria': 'Abrir detalhe da missão',
  'modals.leadDetailModal.close': 'Fechar',
  'modals.leadDetailModal.whoIsThis': 'Quem é?',
  'modals.leadDetailModal.whatDoTheyNeed': 'O que precisam?',
  'modals.leadDetailModal.whatDoISay': 'O que devo dizer?',
  'modals.leadDetailModal.moreProducts': 'Mais produtos',
  'modals.regionDetailsModal.description': 'Visão dos detalhes da missão. Esta vista é só de leitura.',
  'modals.regionDetailsModal.edit': 'Editar',
  'modals.regionDetailsModal.close': 'Fechar',
  'modals.editRegionModal.close': 'Fechar',
  'modals.editRegionModal.description': 'Editar hora e nota da missão. O estado é só de leitura.',
  'modals.editRegionModal.statusReadonlySrOnly': 'O estado é só de leitura.',
  'modals.splitAssignmentDialog.actionLabel': 'Selecionar ação',
  'modals.splitAssignmentDialog.confirmButton': 'Confirmar',
  'modals.addAppointmentModal.companyAriaLabel': 'Selecionar ou introduzir empresa / lead',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmado',
  'modals.rejectLead.title': 'Rejeitar lead',
  'modals.rejectLead.closeAria': 'Fechar diálogo',
  'modals.rejectLead.description': 'Selecione pelo menos um motivo de rejeição.',
  'modals.rejectLead.reasonsLabel': 'Motivos de rejeição',
  'modals.rejectLead.reasonsError': 'Selecione pelo menos um motivo.',
  'modals.rejectLead.otherReasonLabel': 'Outro motivo',
  'modals.rejectLead.otherReasonPlaceholder': 'Descreva o motivo...',
  'modals.rejectLead.otherReasonAria': 'Outro motivo de rejeição',
  'modals.rejectLead.otherReasonError': 'Introduza um motivo.',
  'modals.rejectLead.cancel': 'Cancelar',
  'modals.rejectLead.confirm': 'Rejeitar ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Deixou de estar ativo',
  'modals.rejectLead.reason.temporarilyClosed': 'Temporariamente encerrado',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Conhecido e inadequado',
  'modals.rejectLead.reason.noInterest': 'Sem interesse',
  'modals.rejectLead.reason.wrongContact': 'Interlocutor errado',
  'modals.rejectLead.reason.other': 'Outro',

  // --- SS-145: ui-components + app-components ---
  'app.routes.loadingSettings': 'A carregar definições...',
  'companySearch.filters.companySize': 'Dimensão da empresa',
  'curriculum.modules.pillar': 'Pilar',
  'curriculum.modules.selectLevel': 'Selecionar nível',
  'curriculum.modules.selectPillar': 'Selecionar pilar',
  'curriculum.modules.selectPillarOption': 'Selecionar pilar',
  'learning.lessonViewer.audioNotSupported': 'O seu browser não suporta áudio.',
  'learning.lessonViewer.complete': 'Concluir',
  'learning.lessonViewer.formatNotSupported': 'Formato não suportado',
  'learning.lessonViewer.videoNotSupported': 'O seu browser não suporta vídeo.',
  'learning.moduleEditor.pillar': 'Pilar',
  'learning.moduleEditor.pillarLabel': 'Pilar',
  'learning.tabs.availableLessons': 'Lições disponíveis',
  'learning.tabs.availableQuizzes': 'Quizzes disponíveis',
  'missions.management.demoPerformed': 'Demo realizada',
  'missions.management.demoPerformedLabel': 'Demo realizada',
  'missions.management.kpiDescription': 'Decisor contactado, demo realizada, receita',
  'missions.management.moreActions': 'Mais ações para a missão',
  'missions.management.publish': 'Publicar',
  'missions.management.searchPlaceholder': 'Pesquisar (nome/região/tema/produto)',
  'mobile.layout.closeMenu': 'Fechar menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'Sem conteúdo offline disponível',
  'mobile.layout.offlinePerformance': 'Para melhor desempenho offline',
  'navigation.tileCard.openActions': 'Abrir ações do bloco',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Turíngia',
  'scout.sprints.ciEstimate': 'Estimativa de tempo de execução CI',
  'scout.sprints.estimatedMinutes': 'Minutos estimados',
  'styleGuide.charts.noStatusColors': 'Os gráficos não devem usar cores de estado',
  'styleGuide.confirmation': 'Confirmação',
  'styleGuide.description': 'Descrição',
  'styleGuide.statusSemantics.success': 'Sucesso = Concluído / OK',
  'tickets.list.filterPriority': 'Filtrar por prioridade',
  'ui.calendar.nextMonth': 'Mês seguinte',
  'ui.errorBoundary.returnToDashboard': 'Voltar ao painel',
  'ui.impersonation.selectImpersonation': 'Selecionar impersonação',
  'ui.impersonation.selectUser': 'Selecionar utilizador:',
  'ui.routingPreview.openAppleMaps': 'Abrir no Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Abrir no Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} paragens · {{distance}} km · {{time}} min (estimado)',
  'ui.routingPreview.title': 'Pré-visualização da rota',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Notas adicionais',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Adicionar compromisso',
  'scout.help.selectArticle': 'Selecione um artigo à esquerda ou use a pesquisa para abrir um artigo de ajuda.',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': 'Relatórios de visita em aberto',
  'scout.visitReport.compliance.description': 'Tem {{count}} relatórios de visita em aberto. Preencha-os primeiro.',
  'scout.visitReport.compliance.lockoutTitle': 'Relatórios obrigatórios',
  'scout.visitReport.compliance.lockoutDescription': 'Preencha todos os relatórios de visita em aberto antes de continuar.',
  'scout.visitReport.compliance.deferButton': 'Preencher mais tarde',
  'scout.visitReport.compliance.deferCount': '{{remaining}} adiamentos restantes',
  'scout.visitReport.compliance.noDeferrals': 'Sem adiamentos disponíveis',
  'scout.visitReport.compliance.fillReport': 'Preencher relatório',
  'scout.visitReport.compliance.morningLockout': 'Planeamento diário bloqueado até todos os relatórios em aberto serem preenchidos.',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': 'Plano curricular',
  'learning.lehrplan.subtitle': 'Gerir plano curricular e objetivos de aprendizagem',
  'learning.curriculumPlanning.title': 'Planeamento curricular',
  'learning.curriculumPlanning.subtitle': 'Estruturar plano curricular e atribuir conteúdos',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': 'Visão geral das aplicações',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': 'Seguinte',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys used in table/modal)
  'crm.leads': 'Leads',
  'crm.closedWon': 'Fechos ganhos',
  'crm.searchPlaceholder': 'Pesquisar leads...',
  'crm.name': 'Nome',
  'crm.company': 'Empresa',
  'crm.contact': 'Contacto',
  'crm.source': 'Origem',
  'crm.value': 'Valor',
  'crm.lastContact': 'Último contacto',
  'crm.viewDetails': 'Ver detalhes',
  'crm.editLead': 'Editar lead',
  'crm.addNote': 'Adicionar nota',
  'crm.convertToCustomer': 'Converter em cliente',
  'crm.deleteLead': 'Eliminar lead',
  'crm.leadDetails': 'Detalhes do lead',
  'crm.addNewLead': 'Criar novo lead',
  'crm.viewLeadDetails': 'Ver detalhes do lead',
  'crm.createNewLead': 'Criar novo lead',
  'crm.fullName': 'Nome completo',
  'crm.email': 'E-mail',
  'crm.phone': 'Telefone',
  'crm.estimatedValue': 'Valor estimado',
  'crm.notes': 'Notas',
  'crm.status.new': 'Novo',
  'crm.status.contacted': 'Contactado',
  'crm.status.qualified': 'Qualificado',
  'crm.status.proposal': 'Proposta',
  'crm.status.negotiation': 'Negociação',
  'crm.status.closedWon': 'Ganho',
  'crm.status.closedLost': 'Perdido',
  'crm.source.website': 'Site',
  'crm.source.referral': 'Recomendação',
  'crm.source.tradeShow': 'Feira',
  'crm.source.coldCall': 'Prospecção a frio',
  'crm.source.socialMedia': 'Redes sociais',
  'crm.source.emailCampaign': 'Campanha de e-mail',

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': 'Estados Unidos',
  'country.CA': 'Canadá',
  'country.MX': 'México',
  'country.GB': 'Reino Unido',
  'country.DE': 'Alemanha',
  'country.FR': 'França',
  'country.other': 'Outro',

  // Business type (supplier — CompanyInfoSection uses businessType.*)

  // Missing keys (added from en/de)
  'common.saving': 'A guardar…',
  'common.archive': 'Arquivar',
  'scout.missions.industries.placeholder': 'Selecionar setores',
  'scout.missions.industries.search': 'Pesquisar setores...',
  'scout.missions.industries.empty': 'Nenhum setor encontrado',
  'scout.missions.products.placeholder': 'Selecionar famílias de produtos',
  'scout.missions.products.search': 'Pesquisar famílias de produtos...',
  'scout.missions.products.empty': 'Nenhuma família de produtos encontrada',
  'scout.search.selectStatus': 'Selecionar estado...',
  'scout.dailyPlanning.jokerAdd': 'Usar joker',
  'scout.dailyPlanning.jokerTitle': 'Paragem joker',
  'scout.dailyPlanning.jokerUsed': 'usado',
  'scout.dailyPlanning.jokerLimitReached': 'Limite diário de paragens joker atingido.',
  'scout.dailyPlanning.jokerCompany': 'Empresa',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Introduzir nome da empresa',
  'scout.dailyPlanning.jokerReason': 'Motivo',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Por que é necessária esta paragem?',
  'scout.dailyPlanning.jokerCancel': 'Cancelar',
  'scout.dailyPlanning.jokerSubmit': 'Usar joker',
  'scout.dailyPlanning.jokerCreateError': 'Não foi possível criar a paragem joker.',
  'missions.management.decisionMakerMet': 'Decisor contactado',
  'missions.management.wonAmount': 'Valor ganho',
  'common.active': 'Ativo',
  'common.archived': 'Arquivado',
  'common.planned': 'Planeado',
  'missionControl.totalLeads': 'Total de leads',
  'missionControl.completedLeads': 'Leads concluídos',

  'survey.contact.name': 'Nome',
  'survey.contact.namePlaceholder': 'Introduzir nome',
  'survey.contact.function': 'Função / Cargo',
  'survey.contact.functionPlaceholder': 'Introduzir função',
  'survey.contact.email': 'E-mail',
  'survey.contact.emailPlaceholder': 'Introduzir endereço de e-mail',
  'survey.contact.phone': 'Telefone',
  'survey.contact.phonePlaceholder': 'Introduzir número de telefone',
  'survey.contact.isDecisionMaker': 'É decisor?',
}
